  // import React from "react";
  // import {
  //   Button,
  //   Card,
  //   CardHeader,
  //   CardBody,
  //   CardFooter,
  //   Label,
  //   FormGroup,
  //   Form,
  //   Alert,
  //   Input,
  //   InputGroupAddon,
  //   InputGroupText,
  //   InputGroup,
  //   Container,
  //   Col,
  //   Row,
  //   Modal,
  //   ModalBody,
  //   ModalFooter,
  // } from "reactstrap";
  // import cookie from "react-cookies";
  // import { connect } from "react-redux";
  // import "components/custom.css";
  // import API from "api.js";
  // import { Navigate, NavLink, Link } from "react-router-dom";
  // import { setToken, setUser, setLogo, setSub, setLoader } from "action/index.js";
  // import SimpleReactValidator from "simple-react-validator";
  // import { Helmet } from "react-helmet";
  // import ReactGA from "react-ga";
  // import ReactPixel from "react-facebook-pixel";
  // import NotificationAlert from "react-notification-alert";
  // import { GoogleLogin } from "@react-oauth/google";
  // import FacebookLogin from "react-facebook-login";
  // import { store } from "store/index";
  // import { isMobile } from "react-device-detect";
  // import GoogleBtn from "components/GoogleBtn/GoogleBtn";
  // import PhoneInputField from "components/Inputs/PhoneInputField";

  // const mapStateToProps = (state) => {
  //   return {
  //     token: state.token,
  //   };
  // };
  // const mapDispatchToProps = (dispatch) => {
  //   return {
  //     setToken: (tok) => dispatch(setToken(tok)),
  //     setUser: (user) => dispatch(setUser(user)),
  //     setSub: (sub) => dispatch(setSub(sub)),
  //     setLogo: (sub) => dispatch(setLogo(sub)),
  //   };
  // };

  // const MESSAGE =
  //   "Multiple Logins Detected! Please Logout from other device or mobile, or Change your Password!";
  // const MESSAGE_ONE = "Successfully logged out from the system.";

  // class Login extends React.Component {
  //   constructor(props) {
  //     super(props);
  //     this.state = {
  //       error_status: false,
  //       error_status_message: MESSAGE,
  //       alert_color: "danger",
  //       email: "",
  //       password: "",
  //       // showPassword: false,
  //       passwordVisible: false,
  //       login: false,
  //       error: null,
  //       error_bag: null,
  //       loginLock: false,
  //       taskModal: false,
  //       task_success_bag: "",
  //       task_error_bag: "",
  //       task_name: "",
  //       task_phone: "",
  //       task_email: "",
  //       task_institute: "",
  //       logoIcon: "/images/logol.png",
  //       isMainSite:
  //         window.location.hostname.split(".").shift() === "www" ? true : false,
  //     };
  //     this.validator = new SimpleReactValidator();
  //     this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
  //   }
  //   componentDidMount() {
  //     store.dispatch(setLoader(true));
  //     ReactGA.initialize("UA-157984080-1");
  //     ReactGA.pageview(window.location.pathname + window.location.search);
  //     ReactPixel.init("2474090032742391");
  //     ReactPixel.init("197333187452630");
  //     ReactPixel.pageView();
  //     // document.body.classList.toggle("login-page");

  //     // 100ms delay. becuase at first url is /session-expired and then changes after some ms
  //     setTimeout(() => {
  //       const { location } = this.props;
  //       const query =
  //         location?.search !== "" ? location?.search.split("?")[1] : "";

  //       this.setState({
  //         error_status:
  //           location?.pathname === "/auth/login/session-expired" ||
  //             query === "logout"
  //             ? true
  //             : false,
  //         error_status_message: query === "logout" ? MESSAGE_ONE : MESSAGE,
  //         alert_color: query === "logout" ? "success" : "danger",
  //       });
  //     }, 100);

  //     if (this.props.token !== null && this.props.token !== "null") {
  //       this.props.history.push("/admin/dashboard");
  //     }

  //     if (this.state.error_status) {
  //       this.notify(2, this.state.error_status_message);
  //     }
  //   }
  //   // componentWillUnmount() {
  //   //   document.body.classList.toggle("login-page");
  //   // }

  //   notify = (type, message) => {
  //     switch (type) {
  //       case 1:
  //         type = "success";
  //         break;
  //       case 2:
  //         type = "danger";
  //         break;
  //       default:
  //         break;
  //     }
  //     var options = {};
  //     options = {
  //       place: "tr",
  //       message: (
  //         <div>
  //           <div>{message}</div>
  //         </div>
  //       ),
  //       type: type,
  //       icon: "now-ui-icons ui-1_bell-53 fa fa-bell",
  //       autoDismiss: 10,
  //     };
  //     this.refs.notificationAlert.notificationAlert(options);
  //   };

  //   postLogIn = async () => {
  //     console.log("button clicked");

  //     if (this.state.loginLock) {
  //       return;
  //     }
  //     console.log("1111");

  //     if (!this.validator.allValid()) {
  //       this.validator.showMessages();
  //       this.forceUpdate();
  //       return;
  //     }
  //     this.setState({ error_bag: null, loginLock: true });
  //     const { executeRecaptcha } = this.props;
  //     console.log("executeRecaptcha==", executeRecaptcha);

  //     if (!executeRecaptcha) {
  //       this.setState({ error_bag: "Captcha not ready", loginLock: false });
  //       return;
  //     }

  //     // Get reCAPTCHA token
  //     let recaptchaToken = "";
  //     try {
  //       recaptchaToken = await executeRecaptcha("login_action");
  //       // console.log("Captcha token:", recaptchaToken);
  //     } catch (e) {
  //       this.setState({ error_bag: "Captcha error", loginLock: false });
  //       return;
  //     }

  //     var bodyFormData = new FormData();
  //     bodyFormData.set("email", this.state.email.trim());
  //     bodyFormData.set("password", this.state.password);
  //     bodyFormData.set("subdomain", window.location.hostname.split(".").shift());
  //     bodyFormData.set("recaptcha_token", recaptchaToken); // Captcha token added

  //     let res = null;
  //     try {
  //       const url = `${process.env.REACT_APP_LOGIN_URL}/api/v2/login`;
  //       console.log("url---", url);

  //       res = await API({
  //         url,
  //         method: "POST",
  //         data: bodyFormData,
  //       });
  //     } catch (error) { }

  //     if (res === null || res === undefined) {
  //       // in case server not responding.
  //     } else if (res.status === 200) {
  //       const expires = new Date();
  //       expires.setDate(Date.now() + 1000 * 60 * 60);
  //       this.props.setToken(res.data.access_token);
  //       this.props.setUser(res.data.user);
  //       this.props.setLogo(res.data.image);
  //       let sub = res.data.user.active_subscription.length === 0 ? false : true;
  //       this.props.setSub(sub);
  //       if (res.status === 200) {
  //         // window.location.href  = "/admin/dashboard";
  //         // this.props.history.push("/admin/dashboard");
  //         //this.setState({login:true,loginLock:false});
  //       }
  //     } else if (res.response.status === 422) {
  //       this.setState({ error: res.response });
  //       let str = "";
  //       console.log("this.state.error==", this.state.error);

  //       Object.values(this.state.error.data.errors).forEach((val) => {
  //         str += val[0] + "\n";
  //       });
  //       this.setState({ error_bag: str, loginLock: false });
  //     } else if (res.response.status === 402) {
  //       if (
  //         res.response.data.error === "google" ||
  //         res.response.data.error === "facebook"
  //       ) {
  //         this.setState({
  //           error_bag: `This email address is linked to a social account. Please continue with ${res.response.data.error}`,
  //           loginLock: false,
  //         });
  //       } else if (res.response.data.error === "DELETED") {
  //         this.setState({
  //           error_bag: res.response.data.message,
  //           loginLock: false,
  //         });
  //       } else {
  //         this.setState({ error_bag: "Wrong credentials.", loginLock: false });
  //       }
  //     }
  //   };

  //   post20taskRequest = async (e) => {
  //     e.preventDefault();
  //     if (
  //       this.state.task_name == "" ||
  //       this.state.task_phone == "" ||
  //       this.state.task_email == "" ||
  //       this.state.task_institute == ""
  //     ) {
  //       this.setState({ task_error_bag: "Please fill all fields!" });
  //     } else {
  //       this.setState({ task_error_bag: "" });
  //       var bodyFormData = new FormData();
  //       bodyFormData.set("name", this.state.task_name);
  //       bodyFormData.set("phone", this.state.task_phone);
  //       bodyFormData.set("email", this.state.task_email);
  //       bodyFormData.set("institute", this.state.task_institute);
  //       console.log("bodyFormData==", bodyFormData);
  //       console.log(this.state);
  //       let res = null;
  //       try {
  //         res = await API({
  //           method: "POST",
  //           url: "/task-request-submit-data",
  //           data: bodyFormData,
  //         });
  //       } catch (error) { }
  //       console.log(res);
  //       if (res.status === 200) {
  //         this.setState({ task_success_bag: "Request Submitted Successfully!" });
  //         setTimeout(function () {
  //           window.location.reload();
  //         }, 1000);
  //       } else {
  //         this.setState({ task_error_bag: "Unable to submit request!" });
  //       }
  //     }
  //   };

  //   showTaskModal = () => {
  //     this.setState({ taskModal: true });
  //   };

  //   closeTaskModal = () => {
  //     this.setState({ taskModal: false });
  //   };

  //   submitForm = (e) => {
  //     e.preventDefault();
  //     this.postLogIn();
  //   };

  //   facebookSignUp = (response) => {
  //     console.log(response);
  //     API({
  //       method: "POST",
  //       url: "/fbSignUp",
  //       data: response,
  //     })
  //       .then((res) => {
  //         console.log(res);
  //         this.afterRequest(res);
  //       })
  //       .catch((err) =>
  //         this.setState({
  //           error_bag: "Something went wrong. Please try again later.",
  //           loginLock: false,
  //         })
  //       );
  //   };

  //   googleSignUp = (credentialResponse) => {
  //     store.dispatch(setLoader(false));
  //     API({
  //       method: "POST",
  //       url: "/googleSignUp",
  //       data: credentialResponse,
  //     })
  //       .then((res) => {
  //         console.log(res);
  //         this.afterRequest(res);
  //       })
  //       .catch((err) => {
  //         // this.setState({error_bag:"Something went wrong. Please try again later.",loginLock:false});
  //       });
  //   };

  //   afterRequest = (res) => {
  //     if (res.status === 200) {
  //       const expires = new Date();
  //       expires.setDate(Date.now() + 1000 * 60 * 60);
  //       this.props.setToken(res.data.original.access_token);
  //       this.props.setUser(res.data.original.user);
  //       this.props.setLogo(res.data.original.image);
  //       let sub =
  //         res.data.original.user.active_subscription.length === 0 ? false : true;
  //       this.props.setSub(sub);
  //       console.log(res.status === 200);
  //       if (res.status === 200) {
  //         console.log(res.status);
  //         window.location.href = "/admin/dashboard";
  //         //this.setState({login:true,loginLock:false});
  //       }
  //     } else if (res.response.status === 422) {
  //       this.setState({ error: res.response });
  //       let str = "";

  //       Object.values(this.state.error.data.errors).forEach((val) => {
  //         str += val[0] + "\n";
  //       });
  //       this.setState({ error_bag: str, loginLock: false });
  //     } else if (res.response.status === 402) {
  //       this.setState({
  //         error_bag: "Something went wrong. Please try again later.",
  //         loginLock: false,
  //       });
  //     }
  //   };

  //   changeInput = (e) => {
  //     let { name, value } = e.target;
  //     this.setState({ [name]: value });
  //   };

  //   // togglePasswordVisibility = () => {
  //   //   this.setState((prevState) => ({
  //   //     showPassword: !prevState.showPassword,
  //   //   }));
  //   // };
  //   togglePasswordVisibility() {
  //     this.setState((prevState) => ({
  //       passwordVisible: !prevState.passwordVisible,
  //     }));
  //   }
  //   changeInput = (e) => {
  //     this.setState({ [e.target.name]: e.target.value });
  //   };
  //   render() {
  //     const { token, setToken } = this.props;

  //     console.log("this.props", this.props);

  //     if (this.state.login) {
  //       //return (<Navigate to="/admin/dashboard" replace />);
  //     }
  //     if (this.props.token) {
  //       return <Navigate to="/admin/dashboard" replace />;
  //     }
  //     return (
  //       <div className="innerPage">
  //         <div className="login-page">
  //           <Helmet>
  //             <title>Language Academy Login | Access Your Account</title>
  //             <meta name="twitter:title" content="Login - Language Academy" />
  //             <meta property="og:title" content="Login - Language Academy" />
  //             <meta
  //               name="description"
  //               content="Login into your Language Academy account and start practicing for NAATI, PTE and IELTS."
  //             />

  //             <meta
  //               name="twitter:description"
  //               content="Login into your Language Academy account and start practicing for NAATI, PTE and IELTS."
  //             />
  //             <meta
  //               property="og:description"
  //               content="Login into your Language Academy account and start practicing for NAATI, PTE and IELTS."
  //             />
  //           </Helmet>
  //           <div className="notification-div">
  //             <NotificationAlert ref="notificationAlert" zIndex={9999} />
  //           </div>

  //           <div
  //             className="modal fade"
  //             id="staticBackdrop"
  //             data-bs-backdrop="static"
  //             data-bs-keyboard="false"
  //             tabIndex="-1"
  //             aria-labelledby="staticBackdropLabel"
  //             aria-hidden="true"
  //           >
  //             <div className="modal-dialog main-popup">
  //               <div className="modal-content">
  //                 <div className="modal-header">
  //                   <button
  //                     type="button"
  //                     className="close"
  //                     data-bs-dismiss="modal"
  //                     aria-label="Close"
  //                   >
  //                     <span aria-hidden="true">
  //                       <img
  //                         className="img-fluid"
  //                         src="/images/web-new-images/icons/close-icon2.svg"
  //                         alt="LA"
  //                       />
  //                     </span>
  //                   </button>
  //                 </div>
  //                 <div className="modal-body">
  //                   <div className="row align-items-center">
  //                     <div className="col-md-6">
  //                       <div className="main-popup-img">
  //                         <img
  //                           className="img-fluid"
  //                           src="/images/web-new-images/hero_img1.png"
  //                           alt="LA"
  //                         />
  //                       </div>
  //                     </div>
  //                     <div className="col-md-6">
  //                       <div className="main-popup-content">
  //                         <h4 className="popup-title">
  //                           Get our portal for your institute
  //                         </h4>
  //                         <p className="popup-sub-title">
  //                           Submit Your Details Below
  //                         </p>
  //                         <div className="pte-popup-form-start">
  //                           <Form action="" className="form" method="">
  //                             {this.state.task_success_bag && (
  //                               <Alert color="success">
  //                                 {this.state.task_success_bag}
  //                               </Alert>
  //                             )}
  //                             <div className="fieldOuter">
  //                               <label htmlFor="task_name">Name</label>
  //                               <div className="form-input-outer">
  //                                 <input
  //                                   className="form-input"
  //                                   placeholder="Enter Name"
  //                                   type="text"
  //                                   name="task_name"
  //                                   id="task_name"
  //                                   value={this.state.task_name}
  //                                   onChange={(e) => {
  //                                     this.changeInput(e);
  //                                   }}
  //                                   autoComplete="off"
  //                                 />
  //                               </div>
  //                             </div>
  //                             <div className="fieldOuter">
  //                               <label htmlFor="task_phone">Phone Number</label>
  //                               <div className="form-input-outer">
  //                                 <input
  //                                   className="form-input"
  //                                   placeholder="Enter Phone"
  //                                   type="number"
  //                                   name="task_phone"
  //                                   id="task_phone"
  //                                   value={this.state.task_phone}
  //                                   onChange={(e) => {
  //                                     this.changeInput(e);
  //                                   }}
  //                                   autoComplete="off"
  //                                 />
  //                               </div>
  //                             </div>
  //                             <div className="fieldOuter">
  //                               <label htmlFor="task_email">Email</label>
  //                               <div className="form-input-outer">
  //                                 <input
  //                                   placeholder="Enter Email"
  //                                   className="form-input"
  //                                   type="text"
  //                                   name="task_email"
  //                                   id="task_email"
  //                                   value={this.state.task_email}
  //                                   onChange={(e) => {
  //                                     this.changeInput(e);
  //                                   }}
  //                                   autoComplete="off"
  //                                 />
  //                               </div>
  //                             </div>
  //                             <div className="fieldOuter">
  //                               <label htmlFor="task_institute">
  //                                 Institute Name
  //                               </label>
  //                               <div className="form-input-outer">
  //                                 <input
  //                                   className="form-input"
  //                                   placeholder="Enter Institute Name"
  //                                   type="text"
  //                                   name="task_institute"
  //                                   id="task_institute"
  //                                   value={this.state.task_institute}
  //                                   onChange={(e) => {
  //                                     this.changeInput(e);
  //                                   }}
  //                                   autoComplete="off"
  //                                 />
  //                               </div>
  //                             </div>
  //                             <div className="fieldOuter mb-0">
  //                               <button
  //                                 className="primary-btn"
  //                                 onClick={(e) => {
  //                                   this.post20taskRequest(e);
  //                                 }}
  //                               >
  //                                 Submit
  //                               </button>
  //                             </div>
  //                           </Form>
  //                         </div>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           <section className="contentOuter form-page-wrapper login-content mt-80">
  //             <form onSubmit={this.submitForm}>
  //               <div className="form-header">
  //                 <div className="container">
  //                   <div className="row">
  //                     <div className="col-sm-12">
  //                       <h2 className="primary-heading text-center">
  //                         Login To <br className="d-block d-md-none" />{" "}
  //                         <span className="wpl-badge pte-naati-badge text-white">
  //                           Your Account
  //                         </span>
  //                       </h2>
  //                       <div className="loginForm">
  //                         <div className="form-content-outer position-relative">
  //                           <div className="form-content">
  //                             {this.state.error_bag && (
  //                               <Alert className="custom-error" color="warning">
  //                                 {this.state.error_bag}
  //                               </Alert>
  //                             )}
  //                             {this.state.error_status && (
  //                               <Alert className="custom-error" color="danger">
  //                                 {this.state.error_status_message}
  //                               </Alert>
  //                             )}
  //                             <div className="form-img">
  //                               <img
  //                                 className="img-fluid"
  //                                 src="/images/web-new-images/hero_img1.png"
  //                                 alt="LA"
  //                               />
  //                             </div>
  //                             <div className="fieldOuter login-field login-email">
  //                               <Input
  //                                 placeholder="Email"
  //                                 type="text"
  //                                 name="email"
  //                                 value={this.state.email}
  //                                 onChange={(e) => {
  //                                   this.changeInput(e);
  //                                 }}
  //                                 autoComplete="off"
  //                               />
  //                             </div>
  //                             <div className="fieldOuter login-field login-password form-password-input">
  //                               <input
  //                                 className="form-input"
  //                                 placeholder="Password"
  //                                 type={
  //                                   this.state.passwordVisible
  //                                     ? "text"
  //                                     : "password"
  //                                 }
  //                                 name="password"
  //                                 value={this.state.password}
  //                                 onChange={this.changeInput}
  //                                 autoComplete="off"
  //                               />
  //                               {/* <span className="eye"
  //                                 onClick={this.togglePasswordVisibility}></span> */}
  //                               <span
  //                                 className={`eye${this.state.passwordVisible ? " active" : ""
  //                                   }${!this.state.password ? " disabled" : ""}`}
  //                                 onClick={() => {
  //                                   if (this.state.password)
  //                                     this.togglePasswordVisibility();
  //                                 }}
  //                               ></span>
  //                             </div>
  //                             {this.validator.message(
  //                               "Email",
  //                               this.state.email.trim(),
  //                               "required|email"
  //                             )}
  //                             {this.validator.message(
  //                               "Password",
  //                               this.state.password,
  //                               "required"
  //                             )}
  //                             <div className="rememberForgot">
  //                               <div className="rememberMe">
  //                                 <div className="form-check">
  //                                   <input
  //                                     className="form-check-input"
  //                                     type="checkbox"
  //                                     name="flexRadioDefault"
  //                                     id="flexRadioDefault1"
  //                                   />
  //                                   <label
  //                                     className="form-check-label"
  //                                     htmlFor="flexRadioDefault1"
  //                                   >
  //                                     Remember me
  //                                   </label>
  //                                 </div>
  //                               </div>
  //                               <div className="forgotPwd">
  //                                 <NavLink className="mt-5" to="/auth/forgot">
  //                                   <span>Forgot Password?</span>
  //                                 </NavLink>
  //                               </div>
  //                             </div>
  //                             <div className="fieldOuter mb-0">
  //                               <button
  //                                 className="primary-btn"
  //                                 onClick={(e) => {
  //                                   this.postLogIn();
  //                                 }}
  //                               >
  //                                 Login{" "}
  //                                 <img
  //                                   src="/images/web-new-images/right-arrow.svg"
  //                                   alt="LA"
  //                                 />
  //                               </button>
  //                             </div>
  //                             <div className="separator">
  //                               <span>OR</span>
  //                             </div>
  //                             <div className="google-btn">
  //                               <GoogleLogin
  //                                 text="continue_with"
  //                                 size="medium"
  //                                 width={isMobile ? "200" : "400"}
  //                                 onSuccess={this.googleSignUp}
  //                                 onError={() => {
  //                                   console.log("Login Failed");
  //                                 }}
  //                               />
  //                             </div>
  //                             {/* <div className="google-btn">
  //                               <GoogleBtn afterLogin={this.afterRequest} />
  //                             </div> */}
  //                             {/* <div className="text-center fb-parent">
  //                             <FacebookLogin
  //                               appId={import.meta.env.VITE_FACEBOOK_APP_ID}
  //                               autoLoad={false}
  //                               fields="name,email,picture"
  //                               callback={this.facebookSignUp}
  //                               icon="fa-facebook"
  //                               cookie={false}
  //                               textButton="Continue with Facebook"
  //                             />
  //                           </div> */}
  //                           </div>
  //                         </div>
  //                       </div>

  //                       {/* <div className="col-sm-5 registerLink text-center">
  //         {this.state.isMainSite && 
  //           <React.Fragment>
  //             <div className="login-section mb-5">
  //               <p>Login to</p>
  //               <h3>NAATI CCL Portal</h3>
  //               <a href="https://www.laccl.languageacademy.com.au/auth/login" className="themeBtn blueBtn">Login</a>
  //             </div>
  //             <div className="register-section">
  //               <h3>New User?</h3>
  //               <p>Register now to obtain your<br /> Free Mock Test Material</p>
  //               <Link to="/auth/register" className="themeBtn blueBtn">Register</Link>
  //             </div>
  //           </React.Fragment>
  //         }
  //       </div>
  //       <div className="col-sm-12 div20task text-center">
  //        {this.state.isMainSite && <React.Fragment> <h3>Get our portal for your institute</h3>
  //           <p>Have institute? Need portal for students?</p>
  //           <Button
  //               className="themeBtn"
  //               onClick={(e) => {this.showTaskModal()}}
  //             >Request Now</Button></React.Fragment>}
  //       </div> */}

  //                       <input type="submit" style={{ display: "none" }} />
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </form>
  //           </section>
  //           <div
  //             className="full-page-background"
  //             style={{
  //               backgroundImage: `url(${require("assets/img/bg/fabio-mangione.jpg")})`,
  //             }}
  //           />
  //         </div>
  //         <div className="rl-section">
  //           <div className="container">
  //             <div className="row">
  //               <div className="col-lg-12">
  //                 <div className="rl-content">
  //                   <div className="rl-outer">
  //                     <div className="rl-card">
  //                       <div>
  //                         <h3 className="rl-title">
  //                           Get our portal for your institute
  //                         </h3>
  //                         <p className="normal-text">
  //                           Have institute? Need portal for students?
  //                         </p>
  //                       </div>
  //                       <Link to="/auth/login" className="outline-btn">
  //                         REQUEST NOW{" "}
  //                         <img
  //                           src="/images/web-new-images/right-arrow.svg"
  //                           alt="LA"
  //                         />
  //                       </Link>
  //                     </div>
  //                   </div>
  //                   <div className="rl-outer">
  //                     <div className="rl-card">
  //                       <h3 className="rl-title">Login to NAATI CCL Portal</h3>
  //                       <a
  //                         href="https://www.laccl.languageacademy.com.au/auth/login"
  //                         className="outline-btn"
  //                       >
  //                         LOG IN{" "}
  //                         <img
  //                           src="/images/web-new-images/right-arrow.svg"
  //                           alt="LA"
  //                         />
  //                       </a>
  //                     </div>
  //                   </div>
  //                   <div className="rl-outer">
  //                     <div className="rl-card login-new-user">
  //                       <div>
  //                         <h3 className="rl-title">NEW USER?</h3>
  //                         <p className="normal-text">
  //                           Register now to obtain your Free Mock Test Material
  //                         </p>
  //                       </div>
  //                       <Link to="/auth/register" className="primary-btn">
  //                         Register NOW{" "}
  //                         <img
  //                           src="/images/web-new-images/right-arrow.svg"
  //                           alt="LA"
  //                         />
  //                       </Link>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
  // }

  // export default connect(mapStateToProps, mapDispatchToProps)(Login);


  import React, { useState, useEffect, useRef } from "react";
  import { Form, Alert, Input } from "reactstrap";
  import cookie from "react-cookies";
  import { connect } from "react-redux";
  import "components/custom.css";
  import API from "api.js";
  import { Navigate, NavLink, Link, useNavigate, useLocation } from "react-router-dom";
  import { setToken, setUser, setLogo, setSub, setLoader, setRegionAccess } from "action/index.js";
  import SimpleReactValidator from "simple-react-validator";
  import { Helmet } from "react-helmet";
  import ReactGA from "react-ga";
  import ReactPixel from "react-facebook-pixel";
  // import NotificationAlert from "react-notification-alert";
  import FacebookLogin from "react-facebook-login";
  import { GoogleLogin } from "@react-oauth/google";
  import GoogleBtn from "components/GoogleBtn/GoogleBtn";
  import PhoneInputField from "components/Inputs/PhoneInputField";
  import { toast } from 'react-toastify';

  import { store } from "store/index";
  import { isMobile } from "react-device-detect";
  import LaLoader from "components/Loader/LaLoader.jsx";
  import { useDispatch } from "react-redux";
  import { setAlert } from "action/index";

  const mapStateToProps = (state) => {
    return {
      token: state.token,
    };
  };

  const mapDispatchToProps = (dispatch) => {
    return {
      setToken: (tok) => dispatch(setToken(tok)),
      setUser: (user) => dispatch(setUser(user)),
      setSub: (sub) => dispatch(setSub(sub)),
      setLogo: (sub) => dispatch(setLogo(sub)),
      setRegionAccess: (region_access) => dispatch(setRegionAccess(region_access)),
    };
  };

  const MESSAGE =
    "You have been logged out. Please sign in again to continue.";
  const MESSAGE_ONE = "Successfully logged out from the system.";

  const Login = (props) => {
    const [state, setState] = useState({
      error_status: false,
      error_status_message: MESSAGE,
      alert_color: "danger",
      email: "",
      password: "",
      passwordVisible: false,
      login: false,
      error: null,
      error_bag: null,
      loginLock: false,
      taskModal: false,
      task_success_bag: "",
      task_error_bag: "",
      task_name: "",
      task_phone: "",
      task_email: "",
      task_institute: "",
      logoIcon: "/images/logol.png",
      isMainSite:
        window.location.hostname.split(".").shift() === "www" ? true : false,
    });
    const dispatch = useDispatch("");
    const validatorRef = useRef(new SimpleReactValidator());
    // const notificationAlertRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [, forceUpdate] = useState();

    useEffect(() => {
      store.dispatch(setLoader(true));
      ReactGA.initialize("UA-157984080-1");
      ReactGA.pageview(window.location.pathname + window.location.search);
      ReactPixel.init("2474090032742391");
      ReactPixel.init("197333187452630");
      ReactPixel.pageView();

      // 100ms delay. because at first url is /session-expired and then changes after some ms
      setTimeout(() => {
        const query =
          location?.search !== "" ? location?.search.split("?")[1] : "";

        setState((prev) => ({
          ...prev,
          error_status:
            location?.pathname === "/auth/login/session-expired" ||
              query === "logout"
              ? true
              : false,
          error_status_message: query === "logout" ? MESSAGE_ONE : MESSAGE,
          alert_color: query === "logout" ? "success" : "danger",
        }));
        if (
          location?.pathname === "/auth/login/session-expired" ||
          query === "logout"
        ) {
          if (query === "logout") {
            notify(1, MESSAGE_ONE);
          } else {
            notify(2, MESSAGE);
          }
        }
      }, 100);

      if (props.token !== null && props.token !== "null") {
        navigate("/admin/dashboard");
      }
    }, []);
    const notify = (type, message) => {
      switch (type) {
        case 1:
          toast.success(message);
          break;
        case 2:
          toast.error(message);
          break;
        default:
          toast.info(message);
          break;
      }
    };
    const postLogIn = async () => {
      if (state.loginLock) {
        return;
      }

      if (!validatorRef.current.allValid()) {
        validatorRef.current.showMessages();
        forceUpdate({});
        return;
      }
      setState((prev) => ({ ...prev, error_bag: null, loginLock: true }));
      const { executeRecaptcha } = props;

      if (!executeRecaptcha) {
        setState((prev) => ({
          ...prev,
          error_bag: "Captcha not ready",
          loginLock: false,
        }));
        return;
      }

      // Get reCAPTCHA token
      let recaptchaToken = "";
      try {
        recaptchaToken = await executeRecaptcha("login_action");
      } catch (e) {
        setState((prev) => ({
          ...prev,
          error_bag: "Captcha error",
          loginLock: false,
        }));
        return;
      }

      const bodyFormData = new FormData();
      bodyFormData.set("email", state.email.trim());
      bodyFormData.set("password", state.password);
      bodyFormData.set("subdomain", window.location.hostname.split(".").shift());
      bodyFormData.set("recaptcha_token", recaptchaToken);

      let res = null;
      try {
        const url = `${import.meta.env.VITE_LOGIN_URL}/api/v2/login`;

        res = await API({
          url,
          method: "POST",
          data: bodyFormData,
        });
        if (res === null || res === undefined) {
          // in case server not responding.
          toast.error("Server not responding. Please try again.");
          setState((prev) => ({ ...prev, loginLock: false }));
        } else if (res.status === 200) {
          const expires = new Date();
          expires.setDate(Date.now() + 1000 * 60 * 60);
          props.setToken(res.data.access_token);
          props.setUser(res.data.user);
          props.setLogo(res.data.image);
          props.setRegionAccess(res.data.user.region_access);
          console.log("Region Access in the Login  : ",res?.data?.user?.region_access)
          let sub = res.data.user.active_subscription.length === 0 ? false : true;
          props.setSub(sub);
          if (res.status === 200) {
            // window.location.href  = "/admin/dashboard";
            // navigate("/admin/dashboard");
            // setState((prev) => ({...prev, login: true, loginLock: false}));
          }
        }
        else if (res.response.status === 401) {
      if (res.response.data.code === "blocked-region-access") {
        navigate("/invalid/region");
      }
    }

      } 
      catch (error) {
        const resp = error?.response;
          dispatch(
            setAlert({
              flag: true,
              type: 2,
              message: `${resp?.data?.message || "Something went wrong. Please try again."}`,
            })
          );
        setState((prev) => ({ ...prev, loginLock: false }));
        return;
      }
    };

    const post20taskRequest = async (e) => {
      e.preventDefault();
      if (
        state.task_name === "" ||
        state.task_phone === "" ||
        state.task_email === "" ||
        state.task_institute === ""
      ) {
        setState((prev) => ({
          ...prev,
          task_error_bag: "Please fill all fields!",
        }));
      } else {
        setState((prev) => ({ ...prev, task_error_bag: "" }));
        const bodyFormData = new FormData();
        bodyFormData.set("name", state.task_name);
        bodyFormData.set("phone", state.task_phone);
        bodyFormData.set("email", state.task_email);
        bodyFormData.set("institute", state.task_institute);
        console.log("bodyFormData==", bodyFormData);
        console.log(state);
        let res = null;
        try {
          res = await API({
            method: "POST",
            url: "/task-request-submit-data",
            data: bodyFormData,
          });
        } catch (error) { }
        console.log(res);
        if (res.status === 200) {
          toast.success("Request Submitted Successfully!");
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        } else {
          toast.error("Unable to submit request!");
        }
      }
    };

    const showTaskModal = () => {
      setState((prev) => ({ ...prev, taskModal: true }));
    };

    const closeTaskModal = () => {
      setState((prev) => ({ ...prev, taskModal: false }));
    };

    const submitForm = (e) => {
      e.preventDefault();
      postLogIn();
    };

    const facebookSignUp = (response) => {
      API({
        method: "POST",
        url: "/fbSignUp",
        data: response,
      })
        .then((res) => {
          afterRequest(res);
        })
        .catch((err) =>
          setState((prev) => ({
            ...prev,
            error_bag: "Something went wrong. Please try again later.",
            loginLock: false,
          }))
        );
    };

    const googleSignUp = (credentialResponse) => {
      store.dispatch(setLoader(false));
      API({
        method: "POST",
        url: "/googleSignUp",
        data: credentialResponse,
      })
        .then((res) => {
          afterRequest(res);
        })
        .catch((err) => {
          // setState((prev) => ({...prev, error_bag:"Something went wrong. Please try again later.", loginLock: false}));
        });
    };

    const afterRequest = (res) => {
      if (res.status === 200) {
        props.setToken(res.data.original.access_token);
        props.setUser(res.data.original.user);
        props.setLogo(res.data.original.image);
        let sub =
          res.data.original.user.active_subscription.length === 0 ? false : true;
        props.setSub(sub);
         props.setRegionAccess(res.data.original.user.region_access || false);
        if (res.status === 200) {
          window.location.href = "/admin/dashboard";
          //setState((prev) => ({...prev, login: true, loginLock: false}));
        }
      } else if (res.response.status === 422) {
        setState((prev) => ({ ...prev, error: res.response }));
        let str = "";

        Object.values(res.response.data.errors).forEach((val) => {
          str += val[0] + "\n";
        });
        toast.error(str);
        setState((prev) => ({ ...prev, loginLock: false }));
      } else if (res.response.status === 402) {
        toast.error("Something went wrong. Please try again later.");
        setState((prev) => ({
          ...prev,
          loginLock: false,
        }));
      }
    };

    const changeInput = (e) => {
      let { name, value } = e.target;
      setState((prev) => ({ ...prev, [name]: value }));
    };

    const togglePasswordVisibility = () => {
      setState((prev) => ({
        ...prev,
        passwordVisible: !prev.passwordVisible,
      }));
    };

    if (state.login) {
      //return (<Navigate to="/admin/dashboard" replace />);
    }
    if (props.token) {
      return <Navigate to="/admin/dashboard" replace />;
    }

    const isRecaptchaReady = !!props.executeRecaptcha;

    return (
      <div className="innerPage">
        <div className="login-page">
          <LaLoader show={state.loginLock} />
          <Helmet>
            <title>Language Academy Login | Access Your Account</title>
            <meta name="twitter:title" content="Login - Language Academy" />
            <meta property="og:title" content="Login - Language Academy" />
            <meta
              name="description"
              content="Login into your Language Academy account and start practicing for NAATI, PTE and IELTS."
            />

            <meta
              name="twitter:description"
              content="Login into your Language Academy account and start practicing for NAATI, PTE and IELTS."
            />
            <meta
              property="og:description"
              content="Login into your Language Academy account and start practicing for NAATI, PTE and IELTS."
            />
          </Helmet>
          <div className="notification-div"></div>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog main-popup">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">
                      <img
                        className="img-fluid"
                        src="/images/web-new-images/icons/close-icon2.svg"
                        alt="LA"
                      />
                    </span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="main-popup-img">
                        <img
                          className="img-fluid"
                          src="/images/web-new-images/hero_img1.png"
                          alt="LA"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="main-popup-content">
                        <h4 className="popup-title">
                          Get our portal for your institute
                        </h4>
                        <p className="popup-sub-title">
                          Submit Your Details Below
                        </p>
                        <div className="pte-popup-form-start">
                          <Form action="" className="form" method="">
                            {state.task_success_bag && (
                              <Alert color="success">
                                {state.task_success_bag}
                              </Alert>
                            )}
                            <div className="fieldOuter">
                              <label htmlFor="task_name">Name</label>
                              <div className="form-input-outer">
                                <input
                                  className="form-input"
                                  placeholder="Enter Name"
                                  type="text"
                                  name="task_name"
                                  id="task_name"
                                  value={state.task_name}
                                  onChange={(e) => {
                                    changeInput(e);
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="task_phone">Phone Number</label>
                              <div className="form-input-outer">
                                <input
                                  className="form-input"
                                  placeholder="Enter Phone"
                                  type="number"
                                  name="task_phone"
                                  id="task_phone"
                                  value={state.task_phone}
                                  onChange={(e) => {
                                    changeInput(e);
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="task_email">Email</label>
                              <div className="form-input-outer">
                                <input
                                  placeholder="Enter Email"
                                  className="form-input"
                                  type="text"
                                  name="task_email"
                                  id="task_email"
                                  value={state.task_email}
                                  onChange={(e) => {
                                    changeInput(e);
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="task_institute">
                                Institute Name
                              </label>
                              <div className="form-input-outer">
                                <input
                                  className="form-input"
                                  placeholder="Enter Institute Name"
                                  type="text"
                                  name="task_institute"
                                  id="task_institute"
                                  value={state.task_institute}
                                  onChange={(e) => {
                                    changeInput(e);
                                  }}
                                  autoComplete="off"
                                />
                              </div>
                            </div>
                            <div className="fieldOuter mb-0">
                              <button
                                className="primary-btn"
                                onClick={(e) => {
                                  post20taskRequest(e);
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </Form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section className="contentOuter form-page-wrapper login-content mt-80">
            <form onSubmit={submitForm}>
              <div className="form-header">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="primary-heading text-center">
                        Login To <br className="d-block d-md-none" />{" "}
                        <span className="wpl-badge pte-naati-badge text-white">
                          Your Account
                        </span>
                      </h2>
                      <div className="loginForm">
                        <div className="form-content-outer position-relative">
                          <div className="form-content">
                            {/* {state.error_bag && (
                              <Alert className="custom-error" color="warning">
                                {state.error_bag}
                              </Alert>
                            )}
                            {state.error_status && (
                              <Alert className="custom-error" color="danger">
                                {state.error_status_message}
                              </Alert>
                            )} */}
                            <div className="form-img">
                              <img
                                className="img-fluid"
                                src="/images/web-new-images/hero_img1.png"
                                alt="LA"
                              />
                            </div>
                            <div className="fieldOuter login-field login-email">



                              <Input
                                placeholder="Email"
                                type="text"
                                name="email"
                                value={state.email}
                                onChange={(e) => {
                                  changeInput(e);
                                }}
                                autoComplete="email"
                              />
                            </div>
                            <div className="fieldOuter login-field login-password form-password-input">
                              <input
                                className="form-input"
                                placeholder="Password"
                                type={
                                  state.passwordVisible ? "text" : "password"
                                }
                                name="password"
                                value={state.password}
                                onChange={changeInput}
                                autoComplete="new-password"
                              />
                              <span
                                className={`eye${state.passwordVisible ? " active" : ""
                                  }${!state.password ? " disabled" : ""}`}
                                onClick={() => {
                                  if (state.password) togglePasswordVisibility();
                                }}
                              ></span>
                            </div>
                            {validatorRef.current.message(
                              "Email",
                              state.email.trim(),
                              "required|email"
                            )}
                            {validatorRef.current.message(
                              "Password",
                              state.password,
                              "required"
                            )}
                            <div className="rememberForgot">
                              <div className="rememberMe">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    name="flexRadioDefault"
                                    id="flexRadioDefault1"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexRadioDefault1"
                                  >
                                    Remember me
                                  </label>
                                </div>
                              </div>
                              <div className="forgotPwd">
                                <NavLink className="mt-5" to="/auth/forgot">
                                  <span>Forgot Password?</span>
                                </NavLink>
                              </div>
                            </div>
                            <div className="fieldOuter mb-0">
                              {/* <button
                                className="primary-btn"
                                onClick={(e) => {
                                  postLogIn();
                                }}
                              >
                                Login{" "}
                                <img
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button> */}
                              <button
                                className="primary-btn"
                                onClick={(e) => {
                                  postLogIn();
                                }}
                                disabled={!isRecaptchaReady}
                              >
                                {!isRecaptchaReady ? "Loading..." : "Login"}{" "}
                                <img
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button>
                            </div>
                            <div className="separator">
                              <span>OR</span>
                            </div>
                            <div className="google-btn">
                              <GoogleLogin
                                text="continue_with"
                                size="medium"
                                width={isMobile ? "200" : "400"}
                                onSuccess={googleSignUp}
                                onError={() => {
                                  console.log("Login Failed");
                                }}
                              />
                            </div>
                            {/* <div className="google-btn">
                              <GoogleBtn afterLogin={afterRequest} />
                            </div> */}
                            {/* <div className="text-center fb-parent">
                            <FacebookLogin
                              appId={import.meta.env.VITE_FACEBOOK_APP_ID}
                              autoLoad={false}
                              fields="name,email,picture"
                              callback={facebookSignUp}
                              icon="fa-facebook"
                              cookie={false}
                              textButton="Continue with Facebook"
                            />
                          </div> */}
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-sm-5 registerLink text-center">
        {state.isMainSite &&
          <React.Fragment>
            <div className="login-section mb-5">
              <p>Login to</p>
              <h3>NAATI CCL Portal</h3>
              <a href="https://www.laccl.languageacademy.com.au/auth/login" className="themeBtn blueBtn">Login</a>
            </div>
            <div className="register-section">
              <h3>New User?</h3>
              <p>Register now to obtain your<br /> Free Mock Test Material</p>
              <Link to="/auth/register" className="themeBtn blueBtn">Register</Link>
            </div>
          </React.Fragment>
        }
      </div>
      <div className="col-sm-12 div20task text-center">
      {state.isMainSite && <React.Fragment> <h3>Get our portal for your institute</h3>
          <p>Have institute? Need portal for students?</p>
          <Button
              className="themeBtn"
              onClick={(e) => {showTaskModal()}}
            >Request Now</Button></React.Fragment>}
      </div> */}

                      <input type="submit" style={{ display: "none" }} />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
          <div
            className="full-page-background"
            style={{
              backgroundImage: `url(/assets/img/bg/fabio-mangione.jpg)`,
            }}
          />
        </div>
        <div className="rl-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="rl-content">
                  <div className="rl-outer">
                    <div className="rl-card">
                      <div>
                        <h3 className="rl-title">
                          Get our portal for your institute
                        </h3>
                        <p className="normal-text">
                          Have institute? Need portal for students?
                        </p>
                      </div>
                      <Link to="/auth/login" className="outline-btn">
                        REQUEST NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="rl-outer">
                    <div className="rl-card">
                      <h3 className="rl-title">Login to NAATI CCL Portal</h3>
                      <a
                        href="https://www.laccl.languageacademy.com.au/auth/login"
                        className="outline-btn"
                      >
                        LOG IN{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="rl-outer">
                    <div className="rl-card login-new-user">
                      <div>
                        <h3 className="rl-title">NEW USER?</h3>
                        <p className="normal-text">
                          Register now to obtain your Free Mock Test Material
                        </p>
                      </div>
                      <Link to="/auth/register" className="primary-btn">
                        Register NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="LA"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default connect(mapStateToProps, mapDispatchToProps)(Login);
